export default "__VITE_ASSET__DnRhfavH__"